const REFERRAL_KEY = 'ame_ref';
const REFERRAL_MAX_AGE_DAYS = 90;
const COOKIE_DOMAIN = 'aurelianmarketingengine.com';

type StoredReferral = { code: string; ts: number };

function cookieDomainAttr(): string {
  const host = window.location.hostname;
  return host === COOKIE_DOMAIN || host.endsWith(`.${COOKIE_DOMAIN}`) ? `; domain=.${COOKIE_DOMAIN}` : '';
}

export function captureReferralCode(code: string): void {
  const maxAge = REFERRAL_MAX_AGE_DAYS * 24 * 60 * 60;
  try {
    document.cookie = `${REFERRAL_KEY}=${encodeURIComponent(code)}; max-age=${maxAge}; path=/; SameSite=Lax${cookieDomainAttr()}`;
  } catch {}
  try {
    const value: StoredReferral = { code, ts: Date.now() };
    localStorage.setItem(REFERRAL_KEY, JSON.stringify(value));
  } catch {}
}

export function getStoredReferralCode(): string | undefined {
  try {
    const raw = localStorage.getItem(REFERRAL_KEY);
    if (raw) {
      const parsed = JSON.parse(raw) as Partial<StoredReferral>;
      if (typeof parsed.code === 'string' && parsed.code.startsWith('AME-')) return parsed.code;
    }
  } catch {}
  const match = document.cookie.split('; ').find((c) => c.startsWith(`${REFERRAL_KEY}=`));
  if (!match) return undefined;
  const code = decodeURIComponent(match.slice(REFERRAL_KEY.length + 1));
  return code.startsWith('AME-') ? code : undefined;
}
